(function() {
'use strict';

// ===== DADOS =====
var BASE = 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/';

var CATALOGO_LINHAS = {
  adulto: {
    linha: 'Best For Life',
    nome: 'Amordida Alimentação Natural Super Premium Best For Life Cães Adultos',
    nomeResumo: 'Best For Life Cães Adultos',
    kcalPorKg: 1600,
    sabores: {
      carne: {
        label: 'Carne',
        proteina: 'carne',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LowCarbCarne.webp?v=1779552877',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-adultos?variant=53495136878906'
      },
      frango: {
        label: 'Frango',
        proteina: 'frango',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LowCarbFrango.webp?v=1779552878',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-adultos?variant=53495136911674'
      },
      suino: {
        label: 'Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LowCarbSuino.webp?v=1779552878',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-adultos?variant=53495136944442'
      },
      cordeiro: {
        label: 'Cordeiro',
        proteina: 'cordeiro',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LowCarbCordeiro.webp?v=1779552878',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-adultos?variant=53495136977210'
      },
      pato: {
        label: 'Pato',
        proteina: 'pato',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LowCarbPato.webp?v=1779552877',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-adultos?variant=53495137009978'
      },
      avestruz: {
        label: 'Avestruz',
        proteina: 'avestruz',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LowCarbAvestruz.webp?v=1779552878',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-adultos?variant=53495137042746'
      }
    }
  },

  filhote: {
    linha: 'Best For Life',
    nome: 'Amordida Alimentação Natural Super Premium Best For Life Cães Filhotes',
    nomeResumo: 'Best For Life Cães Filhotes',
    kcalPorKg: 1800,
    sabores: {
      carne: {
        label: 'Carne',
        proteina: 'carne',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/Filhote_Carne_0b5506bb-b39c-44ce-826a-6c53b67f457f.webp?v=1779554397',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-filhotes?variant=53498656883002'
      },
      frango: {
        label: 'Frango',
        proteina: 'frango',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/Filhote_Frango_77f7afbb-a121-4b86-a13d-d132bca5d561.webp?v=1779554396',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-filhotes?variant=53498656915770'
      },
      suino: {
        label: 'Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/Filhote_Suino_2734cbb5-b38b-4e48-bd31-ea96252c798a.webp?v=1779554396',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-filhotes?variant=53498656948538'
      }
    }
  },

  senior: {
    linha: 'Best For Life',
    nome: 'Amordida Alimentação Natural Super Premium Best For Life Cães Sênior',
    nomeResumo: 'Best For Life Cães Sênior',
    kcalPorKg: 1300,
    sabores: {
      carne: {
        label: 'Carne',
        proteina: 'carne',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SeniorCarne.webp?v=1779554564',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-senior?variant=53498659569978'
      },
      frango: {
        label: 'Frango',
        proteina: 'frango',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SeniorFrango.webp?v=1779554564',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-senior?variant=53498659602746'
      },
      suino: {
        label: 'Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SeniorSuino.webp?v=1779554565',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-best-for-life-caes-senior?variant=53498659635514'
      }
    }
  },

  pele: {
    linha: 'Sensitive',
    nome: 'Amordida Alimentação Natural Super Premium Sensitive Cães Adultos e Sênior',
    nomeResumo: 'Sensitive Cães Adultos e Sênior',
    kcalPorKg: 1300,
    sabores: {
      suino: {
        label: 'Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/Sensitivesuino.webp?v=1779554984',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-sensitive-caes-adultos-e-senior?variant=53499774927162'
      },
      super_leve_suino: {
        label: 'Super Leve Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SensitiveSuperLeveSuino.webp?v=1779554984',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-sensitive-caes-adultos-e-senior?variant=53499774959930'
      },
      low_carb_suino: {
        label: 'Low Carb Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SensitiveLowCarbSuino.webp?v=1779554984',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-sensitive-caes-adultos-e-senior?variant=53499774992698'
      },
      tilapia: {
        label: 'Tilápia',
        proteina: 'peixe',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SensitiveTilapia.webp?v=1779554984',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-sensitive-caes-adultos-e-senior?variant=53499775025466'
      },
      cordeiro: {
        label: 'Cordeiro',
        proteina: 'cordeiro',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SensitiveCordeiro.webp?v=1779554984',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-sensitive-caes-adultos-e-senior?variant=53499775058234'
      },
      pato: {
        label: 'Pato',
        proteina: 'pato',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SensitivePato.webp?v=1779554984',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-sensitive-caes-adultos-e-senior?variant=53499775091002'
      },
      avestruz: {
        label: 'Avestruz',
        proteina: 'avestruz',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/SensitiveAvestruz.webp?v=1779554984',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-sensitive-caes-adultos-e-senior?variant=53499775123770'
      }
    }
  },

  gastro: {
    linha: 'Low Fat',
    nome: 'Amordida Alimentação Natural Super Premium Low Fat Cães Adultos e Sênior',
    nomeResumo: 'Low Fat Cães Adultos e Sênior',
    kcalPorKg: 1250,
    sabores: {
      suino: {
        label: 'Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LowFatSuino.webp?v=1779555960',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-low-fat-caes-adultos-e-senior?variant=53499783610682'
      },
      low_carb_suino: {
        label: 'Low Carb Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LowFatLowCarbSuino.webp?v=1779555959',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-low-fat-caes-adultos-e-senior?variant=53499783643450'
      }
    }
  },

  light: {
    linha: 'Light',
    nome: 'Amordida Alimentação Natural Super Premium Light Cães Adultos e Sênior',
    nomeResumo: 'Light Cães Adultos e Sênior',
    kcalPorKg: 1200,
    sabores: {
      carne: {
        label: 'Carne',
        proteina: 'carne',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LightCarne.webp?v=1779556179',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-light-caes-adultos-e-senior?variant=53499788558650'
      },
      frango: {
        label: 'Frango',
        proteina: 'frango',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LightFrango.webp?v=1779556179',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-light-caes-adultos-e-senior?variant=53499788591418'
      },
      suino: {
        label: 'Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/LightSuino.webp?v=1779556179',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-light-caes-adultos-e-senior?variant=53499788624186'
      }
    }
  },

  seletividade: {
    linha: 'Super Paladar',
    nome: 'Amordida Alimentação Natural Super Premium Super Paladar Cães Adultos e Sênior',
    nomeResumo: 'Super Paladar Cães Adultos e Sênior',
    kcalPorKg: 1300,
    sabores: {
      carne: {
        label: 'Carne',
        proteina: 'carne',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/Super_Paladar_Carne_bcec2aa0-5f8b-4faa-b046-356dc07dff29.webp?v=1779556315',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-super-paladar-caes-adultos-e-senior?variant=53499792916794'
      },
      frango: {
        label: 'Frango',
        proteina: 'frango',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/Super_Paladar_Frango_9263b2f2-3783-4c12-bfde-7fda8f9bc38b.webp?v=1779556315',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-super-paladar-caes-adultos-e-senior?variant=53499792949562'
      },
      suino: {
        label: 'Suíno',
        proteina: 'suino',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/Super_Paladar_Suino_3e32d680-a977-4df4-95c9-8e74cc2fb5e1.webp?v=1779556315',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-super-paladar-caes-adultos-e-senior?variant=53499792982330'
      },
      cordeiro: {
        label: 'Cordeiro',
        proteina: 'cordeiro',
        imagem: 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/Super_Paladar_Cordeiro_4fef7d50-97b3-4cd5-8a4b-437e595339a9.webp?v=1779556315',
        url: 'https://amordida.com.br/products/amordida-alimentacao-natural-super-premium-super-paladar-caes-adultos-e-senior?variant=53499793015098'
      }
    }
  }
};

var BENEFICIOS = {
  adulto: [
    { texto: 'Mais energia e disposição no dia a dia' },
    { texto: 'Pelagem mais densa, brilhante e hidratada' },
    { texto: 'Proteína animal acima de 70% — o que o organismo do cão realmente precisa' },
    { texto: 'Digestão mais eficiente, fezes menores e mais firmes' }
  ],

  filhote: [
    { texto: 'Suporte ao desenvolvimento ósseo e muscular na fase mais crítica' },
    { texto: 'DHA para desenvolvimento cerebral e visual' },
    { texto: 'Proteína de alta qualidade para crescimento saudável' },
    { texto: 'Base nutricional completa para uma vida adulta mais saudável' }
  ],

  senior: [
    { texto: 'Glicosamina e condroitina para articulações e mobilidade' },
    { texto: 'Taurina e carnitina para saúde cardiovascular' },
    { texto: 'Proteína leve e de fácil digestão' },
    { texto: 'Mais qualidade de vida e conforto na idade avançada' }
  ],

  pele: [
    { texto: 'Monoproteica — uma única fonte de proteína por produto' },
    { texto: 'Ajuda na redução de coceira, vermelhidão e queda de pelo' },
    { texto: 'Ingredientes selecionados para mínima reatividade' },
    { texto: 'Controle alimentar preciso para identificação de sensibilidades' }
  ],

  gastro: [
    { texto: 'Baixo teor de gordura para digestão mais leve' },
    { texto: 'Fezes mais firmes e regulares' },
    { texto: 'Redução de gases e desconforto abdominal' },
    { texto: 'Alta digestibilidade sem abrir mão da nutrição completa' }
  ],

  light: [
    { texto: 'Menor densidade calórica para auxiliar no controle de peso' },
    { texto: 'Psyllium para maior saciedade' },
    { texto: 'Sem óleos adicionados' },
    { texto: 'Perda de peso gradual sem passar fome' }
  ],

  seletividade: [
    { texto: 'Desenvolvido para cães que recusam alimentos' },
    { texto: 'Variedade de sabores para estimular o interesse' },
    { texto: 'Nutrição completa mesmo para os mais exigentes' },
    { texto: 'Transforma a hora da refeição em um momento mais prazeroso' }
  ]
};

// ===== FEEDBACKS CONTEXTUAIS =====
// Aparecem acima do card após cada resposta
var FEEDBACKS = {
  nome: function(r) {
    return { icon: '🐾', texto: 'Oi! Vamos encontrar a dieta ideal para <strong>' + esc(r.nome_cao) + '</strong>.' };
  },
  peso: function(r) {
    return { icon: '⚖️', texto: 'Com <strong>' + r.peso + 'kg</strong>, vou calcular a porção diária exata para ' + esc(r.nome_cao) + '.' };
  },
  fase: function(r) {
    var msgs = {
      filhote: 'Filhotes precisam de nutrição específica para crescer com saúde. Boa escolha em cuidar cedo! 🌱',
      adulto:  'Na fase adulta, a alimentação define energia, pelagem e longevidade. Vamos acertar nisso. 💪',
      senior:  'Cães sênior merecem cuidado especial. A nutrição certa faz toda a diferença nessa fase. ❤️'
    };
    return { icon: '📅', texto: msgs[r.fase] || '' };
  },
  atividade: function(r) {
    var msgs = {
      sedentario: 'Cães mais calmos precisam de uma porção ajustada para evitar ganho de peso.',
      moderado:   'Atividade moderada é ótima para manter o equilíbrio. Porção calculada com precisão.',
      ativo:      'Cão ativo precisa de mais energia! Vou considerar isso na porção.'
    };
    return { icon: '🏃', texto: msgs[r.atividade] || '' };
  },
  necessidade: function(r) {
    var msgs = {
      saude:        'Perfeito! Alimentação natural de qualidade é o melhor que você pode oferecer. ✨',
      pele:         'Entendido. A linha Sensitive da Amordida é monoproteica — feita para minimizar reações. 🛡️',
      gastro:       'Digestão sensível precisa de leveza e alta digestibilidade. Temos a linha certa pra isso. 💧',
      peso:         'Controle de peso sem sacrifício é possível. Nossa linha Light mantém a saciedade com menos caloria. ⚖️',
      seletividade: 'Cão seletivo tem solução! A Linha Super Paladar foi feita especialmente pra isso. 🍴'
    };
    return { icon: '🎯', texto: msgs[r.necessidade] || '' };
  }
};

// ===== PORÇÃO =====

function getLinhaCatalogo(chaveLinha) {
  return CATALOGO_LINHAS[chaveLinha] || CATALOGO_LINHAS.adulto;
}

function getKcalPorKg(chaveLinha) {
  var linha = getLinhaCatalogo(chaveLinha);
  return linha.kcalPorKg || 1400;
}

function normalizarProteinaSensivel(proteina) {
  var mapa = {
    boi: 'carne',
    carne: 'carne',
    frango: 'frango',
    suino: 'suino',
    peixe: 'peixe',
    tilapia: 'peixe'
  };

  return mapa[proteina] || proteina;
}

function calcularSaboresPermitidos(chaveLinha, proteinasSensiveis) {
  var linha = getLinhaCatalogo(chaveLinha);

  var sensiveis = (proteinasSensiveis || []).map(function(p) {
    return normalizarProteinaSensivel(p);
  });

  return Object.keys(linha.sabores)
    .filter(function(chaveSabor) {
      var sabor = linha.sabores[chaveSabor];
      var proteinaSabor = normalizarProteinaSensivel(sabor.proteina);

      return sensiveis.indexOf(proteinaSabor) === -1;
    })
    .map(function(chaveSabor) {
      return Object.assign(
        { chave: chaveSabor },
        linha.sabores[chaveSabor]
      );
    });
}

var FATOR_ATIVIDADE = {
  sedentario: 0.95,
  moderado: 1.0,
  ativo: 1.1
};

var FATOR_FASE = {
  filhote: 2.0,
  adulto: 1.0,
  senior: 1.0
};

function calcularPorcao(peso, fase, atividade, chaveLinha, sobrepeso) {
  var kcal = getKcalPorKg(chaveLinha);

  var rem = 80 * Math.pow(peso, 0.75);
  var fator = FATOR_ATIVIDADE[atividade] * FATOR_FASE[fase];
  var kcal_dia = rem * fator;

  var reducao =
    (chaveLinha === 'light' || sobrepeso)
      ? 0.8
      : 1.0;

  return Math.round(
    (kcal_dia * reducao / kcal) * 1000
  );
}

// ===== RECOMENDAÇÃO =====
function calcularRecomendacao(r) {
  var linhaKey = 'adulto';
  var aviso = null;
  var criterio = '';

  if (r.fase === 'filhote') {
    linhaKey = 'filhote';

    var avisosFilhote = {
      gastro: 'Para filhotes com sensibilidade gastrointestinal, a linha Filhote pode não ser suficiente sozinha. Recomendamos conversar com nossa equipe antes da compra.',
      peso: 'Filhotes não devem passar por restrição calórica sem orientação. O crescimento depende de nutrição completa e porção adequada.',
      seletividade: 'Para filhotes seletivos, a primeira estratégia é variar os sabores dentro da própria linha Filhote.',
      pele: 'Na fase de filhote, a prioridade é manter uma dieta própria para crescimento. Se houver suspeita de sensibilidade, evitamos as proteínas já identificadas.'
    };

    aviso = avisosFilhote[r.necessidade] || null;
    criterio = 'Linha própria para fase de crescimento';
  } else if (r.necessidade === 'saude') {
    if (r.fase === 'senior') {
      linhaKey = 'senior';
      criterio = 'Manutenção sênior, com foco em vitalidade e cuidado na idade avançada';
    } else {
      linhaKey = 'adulto';
      criterio = 'Manutenção adulta, com foco em saúde geral, energia e rotina alimentar';
    }
  } else if (r.necessidade === 'peso') {
    linhaKey = 'light';
    criterio = 'Controle de peso com menor densidade calórica e mais saciedade';
  } else if (r.necessidade === 'seletividade') {
    linhaKey = 'seletividade';
    criterio = 'Maior palatabilidade para cães que recusam ou enjoam facilmente';
  } else if (r.necessidade === 'gastro') {
    linhaKey = 'gastro';

    if (r.carbo_piora) {
      criterio = 'Digestão sensível com preferência pela opção Low Carb Suíno';
    } else {
      criterio = 'Digestão sensível com baixo teor de gordura';
    }
  } else if (r.necessidade === 'pele') {
    linhaKey = 'pele';

    if (r.sabe_proteina === true && (r.proteinas_sensiveis || []).length > 0) {
      criterio = 'Sensibilidade de pele com exclusão das proteínas informadas';
    } else {
      criterio = 'Sensibilidade de pele com opções monoproteicas para começar com mais controle';
    }
  } else if (r.fase === 'senior') {
    linhaKey = 'senior';
    criterio = 'Manutenção sênior, com foco em vitalidade e cuidado na idade avançada';
  }

  var linha = getLinhaCatalogo(linhaKey);
  var saboresPermitidos = calcularSaboresPermitidos(
    linhaKey,
    r.proteinas_sensiveis || []
  );

  if (r.necessidade === 'gastro' && r.carbo_piora) {
    saboresPermitidos = saboresPermitidos.filter(function(sabor) {
      return sabor.chave === 'low_carb_suino';
    });
  }

  if (!saboresPermitidos.length) {
    if (linhaKey === 'filhote') {
      aviso = 'Atualmente não temos uma alimentação para filhotes que atenda às sensibilidades informadas. Recomendamos entrar em contato com nossa equipe antes da compra.';
    } else if (linhaKey === 'pele') {
      aviso = 'Atualmente não encontramos uma opção Sensitive compatível com as proteínas informadas. Recomendamos entrar em contato com nossa equipe para avaliar o melhor caminho.';
    } else {
      aviso = 'Pelas sensibilidades informadas, não encontramos uma opção segura nessa linha. Recomendamos conversar com nossa equipe antes da compra.';
    }

    saboresPermitidos = [];
  }

  return {
    linhaKey: linhaKey,
    linha: linha.linha,
    nome: linha.nome,
    nomeResumo: linha.nomeResumo,
    titulo: linha.nomeResumo,
    criterio: criterio,
    aviso: aviso,
    saboresPermitidos: saboresPermitidos
  };
}

// ===== ESTADO =====
var respostas = { nome_cao: '', peso: '', fase: '', atividade: '', necessidade: '', sabe_proteina: null, proteinas_sensiveis: [], carbo_piora: null, sobrepeso: null };
var step = 1;

function getTotalSteps() {
  var n = respostas.necessidade;
  if (!n || n === 'saude' || n === 'peso') return 5;
  if (n === 'seletividade') return 6;
  if (n === 'gastro') return 7;
  if (n === 'pele') return respostas.sabe_proteina === true ? 8 : 7;
  return 5;
}

function getLabelStep() {
  if (step <= 2) return 'Sobre o seu cão';
  if (step === 3) return 'Fase de vida';
  if (step === 4) return 'Nível de atividade';
  return 'Necessidade especial';
}

function el(id) { return document.getElementById(id); }
function cao() { return respostas.nome_cao || 'seu cão'; }
function esc(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

// ===== FEEDBACK =====
function mostrarFeedback(fb) {
  if (!fb || !fb.texto) return;
  var wrap = el('gq-feedback');
  var icon = el('gq-feedback-icon');
  var texto = el('gq-feedback-texto');
  if (!wrap) return;
  if (icon) icon.textContent = fb.icon;
  if (texto) texto.innerHTML = fb.texto;
  wrap.style.display = 'flex';
}

function esconderFeedback() {
  var wrap = el('gq-feedback');
  if (wrap) wrap.style.display = 'none';
}

// ===== PROGRESSO =====
function atualizarProgresso() {
  var total = getTotalSteps();
  var pct = Math.round((step / total) * 100);
  var fill = el('guia-progress-fill');
  var pctEl = el('guia-progress-pct');
  var labelEl = el('guia-progress-label');
  if (fill) fill.style.width = pct + '%';
  if (pctEl) pctEl.textContent = pct + '%';
  if (labelEl) labelEl.textContent = getLabelStep();
}

// ===== RENDER OPÇÕES =====
function renderOpcoes(opcoes, valorAtivo) {
  var html = '<div class="guia-opcoes">';
  opcoes.forEach(function(op) {
    var ativa = valorAtivo === op.valor;
    html += '<button class="guia-opcao' + (ativa ? ' guia-opcao--ativa' : '') + '" data-valor="' + op.valor + '">' +
      '<span class="guia-opcao__icon">' + op.icon + '</span>' +
      '<span class="guia-opcao__info">' +
        '<span class="guia-opcao__label">' + op.label + '</span>' +
        (op.sub ? '<span class="guia-opcao__sub">' + op.sub + '</span>' : '') +
      '</span>' +
      '<span class="guia-opcao__check">✓</span>' +
    '</button>';
  });
  return html + '</div>';
}

function bindOpcoes(campo) {
  var c = el('guia-step-content');
  if (!c) return;
  c.querySelectorAll('.guia-opcao').forEach(function(btn) {
    btn.addEventListener('click', function() {
      respostas[campo] = btn.dataset.valor;
      c.querySelectorAll('.guia-opcao').forEach(function(b) {
        b.classList.toggle('guia-opcao--ativa', b.dataset.valor === btn.dataset.valor);
      });
      var nxt = el('gs-next');
      if (nxt) nxt.disabled = false;
    });
  });
}

var acoesPadrao = '<div class="guia-acoes"><button class="guia-btn-primary" id="gs-next" disabled>Continuar</button><button class="guia-btn-secondary" id="gs-back">Voltar</button></div>';

function avancar(feedbackKey) {
  if (feedbackKey && FEEDBACKS[feedbackKey]) {
    mostrarFeedback(FEEDBACKS[feedbackKey](respostas));
  } else {
    esconderFeedback();
  }

  step++;
  renderStep();
  scrollParaCardQuiz();
}

function voltar() {
  esconderFeedback();

  step--;
  renderStep();
  scrollParaCardQuiz();
}

function scrollParaCardQuiz() {
  var feedback = el('gq-feedback');
  var card = el('guia-card');

  var alvo =
    feedback && feedback.style.display !== 'none'
      ? feedback
      : card;

  if (!alvo) return;

  var headerOffset = 86;
  var extraRespiro = 14;

  var posicao =
    alvo.getBoundingClientRect().top +
    window.pageYOffset -
    headerOffset -
    extraRespiro;

  window.scrollTo({
    top: posicao,
    behavior: 'smooth'
  });
}

// ===== RENDER STEP =====
function renderStep() {
  atualizarProgresso();
  var c = el('guia-step-content');
  if (!c) return;

  // Step 1 — Nome
  if (step === 1) {
    esconderFeedback();
    c.innerHTML = '<h2 class="guia-step__titulo">Como se chama seu cão?</h2>' +
      '<p class="guia-step__sub">Vamos personalizar a recomendação para ele.</p>' +
      '<div class="guia-input-wrap"><input class="guia-input" id="gs-nome" placeholder="Nome do cão" value="' + esc(respostas.nome_cao) + '"></div>' +
      '<div class="guia-acoes"><button class="guia-btn-primary" id="gs-next"' + (!respostas.nome_cao ? ' disabled' : '') + '>Continuar</button></div>';
    var inp = el('gs-nome');
    inp.addEventListener('input', function() {
      respostas.nome_cao = inp.value.trim();
      el('gs-next').disabled = !respostas.nome_cao;
    });
    inp.addEventListener('keydown', function(e) { if (e.key === 'Enter' && respostas.nome_cao) avancar('nome'); });
    el('gs-next').addEventListener('click', function() { if (respostas.nome_cao) avancar('nome'); });
    setTimeout(function() { inp.focus(); }, 100);
    return;
  }

  // Step 2 — Peso
  if (step === 2) {
    c.innerHTML = '<h2 class="guia-step__titulo">Qual o peso de <span class="guia-step__nome-destaque">' + esc(cao()) + '</span>?</h2>' +
      '<p class="guia-step__sub">Usamos o peso para calcular a porção diária exata.</p>' +
      '<div class="guia-input-wrap"><input class="guia-input" id="gs-peso" type="number" placeholder="Ex: 10" min="0.5" max="100" step="0.1" value="' + esc(respostas.peso) + '"><span class="guia-input-suffix">kg</span></div>' + acoesPadrao;
    var inp = el('gs-peso');
    inp.addEventListener('input', function() {
      respostas.peso = inp.value;
      el('gs-next').disabled = !respostas.peso || parseFloat(respostas.peso) < 0.5;
    });
    el('gs-next').disabled = !respostas.peso || parseFloat(respostas.peso) < 0.5;
    el('gs-next').addEventListener('click', function() { if (respostas.peso && parseFloat(respostas.peso) >= 0.5) avancar('peso'); });
    el('gs-back').addEventListener('click', voltar);
    return;
  }

  // Step 3 — Fase
  if (step === 3) {
    c.innerHTML = '<h2 class="guia-step__titulo">Qual a fase de <span class="guia-step__nome-destaque">' + esc(cao()) + '</span>?</h2>' +
      '<p class="guia-step__sub">A fase de vida define a linha nutricional base.</p>' +
      renderOpcoes([
        { valor: 'filhote', icon: '🐶', label: 'Filhote', sub: 'Até 10 meses (raças pequenas) ou 15 meses (raças grandes)' },
        { valor: 'adulto',  icon: '🐕', label: 'Adulto',  sub: '' },
        { valor: 'senior',  icon: '❤️', label: 'Sênior',  sub: 'A partir de 7 anos' }
      ], respostas.fase) + acoesPadrao;
    bindOpcoes('fase');
    el('gs-next').disabled = !respostas.fase;
    el('gs-next').addEventListener('click', function() { if (respostas.fase) avancar('fase'); });
    el('gs-back').addEventListener('click', voltar);
    return;
  }

  // Step 4 — Atividade
  if (step === 4) {
    c.innerHTML = '<h2 class="guia-step__titulo">Como é a atividade de <span class="guia-step__nome-destaque">' + esc(cao()) + '</span>?</h2>' +
      '<p class="guia-step__sub">Isso afeta o cálculo da porção diária.</p>' +
      renderOpcoes([
        { valor: 'sedentario', icon: '🛋️', label: 'Sedentário', sub: 'Poucos passeios, maior parte do tempo em casa' },
        { valor: 'moderado',   icon: '🚶', label: 'Moderado',   sub: 'Passeios diários, brincadeiras regulares' },
        { valor: 'ativo',      icon: '🏃', label: 'Ativo',      sub: 'Muito exercício, esportes, cão de trabalho' }
      ], respostas.atividade) + acoesPadrao;
    bindOpcoes('atividade');
    el('gs-next').disabled = !respostas.atividade;
    el('gs-next').addEventListener('click', function() { if (respostas.atividade) avancar('atividade'); });
    el('gs-back').addEventListener('click', voltar);
    return;
  }

  // Step 5 — Necessidade
  if (step === 5) {
    c.innerHTML = '<h2 class="guia-step__titulo"><span class="guia-step__nome-destaque">' + esc(cao()) + '</span> tem alguma necessidade especial?</h2>' +
      '<p class="guia-step__sub">Isso define qual linha de dieta é mais adequada.</p>' +
      renderOpcoes([
        { valor: 'saude',        icon: '❤️', label: 'Não, quero melhorar saúde e bem-estar', sub: 'Alimentação natural de alto padrão' },
        { valor: 'pele',         icon: '✋', label: 'Sensibilidade de pele ou alergia',       sub: 'Coceira, queda de pelo, vermelhidão' },
        { valor: 'gastro',       icon: '🌡️', label: 'Sensibilidade gastrointestinal',        sub: 'Fezes moles, gases, vômitos frequentes' },
        { valor: 'peso',         icon: '⚖️', label: 'Controle de peso',                      sub: 'Sobrepeso ou obesidade' },
        { valor: 'seletividade', icon: '🍴', label: 'Seletividade alimentar',                sub: 'Come muito pouco ou rejeita alimentos' }
      ], respostas.necessidade) + acoesPadrao;
    bindOpcoes('necessidade');
    el('gs-next').disabled = !respostas.necessidade;
    el('gs-next').addEventListener('click', function() {
      if (!respostas.necessidade) return;
      if (respostas.necessidade === 'saude' || respostas.necessidade === 'peso') {
        mostrarFeedback(FEEDBACKS.necessidade(respostas));
        mostrarResultado();
      } else {
        avancar('necessidade');
      }
    });
    el('gs-back').addEventListener('click', voltar);
    return;
  }

  // Sobrepeso template
  var stepSobrepeso = function() {
    c.innerHTML = '<h2 class="guia-step__titulo">O peso de <span class="guia-step__nome-destaque">' + esc(cao()) + '</span> está adequado?</h2>' +
      '<p class="guia-step__sub">Isso ajuda a ajustar a porção diária se necessário.</p>' +
      renderOpcoes([
        { valor: 'nao', icon: '✅', label: 'Sim, está no peso ideal', sub: '' },
        { valor: 'sim', icon: '⚠️', label: 'Não, está acima do peso', sub: '' }
      ], respostas.sobrepeso === false ? 'nao' : respostas.sobrepeso === true ? 'sim' : '') + acoesPadrao;
    el('gs-next').disabled = respostas.sobrepeso === null;
    c.querySelectorAll('.guia-opcao').forEach(function(btn) {
      btn.addEventListener('click', function() {
        respostas.sobrepeso = btn.dataset.valor === 'sim';
        c.querySelectorAll('.guia-opcao').forEach(function(b) { b.classList.toggle('guia-opcao--ativa', b.dataset.valor === btn.dataset.valor); });
        el('gs-next').disabled = false;
      });
    });
    el('gs-next').addEventListener('click', function() { if (respostas.sobrepeso !== null) mostrarResultado(); });
    el('gs-back').addEventListener('click', voltar);
  };

  if (step === 6 && respostas.necessidade === 'seletividade') { stepSobrepeso(); return; }

  // PELE step 6 — sabe proteína
  if (step === 6 && respostas.necessidade === 'pele') {
    c.innerHTML = '<h2 class="guia-step__titulo">Você sabe qual proteína causa reação?</h2>' +
      '<p class="guia-step__sub">Se souber, a recomendação fica ainda mais precisa.</p>' +
      renderOpcoes([
        { valor: 'sim', icon: '✅', label: 'Sim, já identifiquei',  sub: 'Vou indicar quais causam reação' },
        { valor: 'nao', icon: '❓', label: 'Não tenho certeza',      sub: 'Recomendar as proteínas mais seguras' }
      ], respostas.sabe_proteina === true ? 'sim' : respostas.sabe_proteina === false ? 'nao' : '') + acoesPadrao;
    el('gs-next').disabled = respostas.sabe_proteina === null;
    c.querySelectorAll('.guia-opcao').forEach(function(btn) {
      btn.addEventListener('click', function() {
        respostas.sabe_proteina = btn.dataset.valor === 'sim';
        if (btn.dataset.valor === 'nao') respostas.proteinas_sensiveis = [];
        c.querySelectorAll('.guia-opcao').forEach(function(b) { b.classList.toggle('guia-opcao--ativa', b.dataset.valor === btn.dataset.valor); });
        el('gs-next').disabled = false;
      });
    });
    el('gs-next').addEventListener('click', function() { if (respostas.sabe_proteina !== null) avancar(); });
    el('gs-back').addEventListener('click', voltar);
    return;
  }

  if (step === 7 && respostas.necessidade === 'pele' && respostas.sabe_proteina === false) { stepSobrepeso(); return; }

  // PELE step 7 — proteínas
  if (step === 7 && respostas.necessidade === 'pele' && respostas.sabe_proteina === true) {
    var prots = [
      { id: 'frango', label: 'Frango', icon: '🍗' },
      { id: 'boi',    label: 'Boi / Carne bovina', icon: '🐄' },
      { id: 'suino',  label: 'Suíno / Porco', icon: '🥩' },
      { id: 'peixe',  label: 'Peixe', icon: '🐟' }
    ];
    var html = '<h2 class="guia-step__titulo">Quais proteínas causam reação?</h2>' +
      '<p class="guia-step__sub">Selecione todas que já causaram problemas.</p>' +
      '<div class="guia-proteinas">';
    prots.forEach(function(p) {
      var at = respostas.proteinas_sensiveis.indexOf(p.id) !== -1;
      html += '<button class="guia-proteina' + (at ? ' guia-proteina--ativa' : '') + '" data-prot="' + p.id + '">' + p.icon + ' ' + p.label + '</button>';
    });
    html += '</div>' + acoesPadrao;
    c.innerHTML = html;
    el('gs-next').disabled = respostas.proteinas_sensiveis.length === 0;
    c.querySelectorAll('.guia-proteina').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var p = btn.dataset.prot;
        var idx = respostas.proteinas_sensiveis.indexOf(p);
        if (idx === -1) respostas.proteinas_sensiveis.push(p);
        else respostas.proteinas_sensiveis.splice(idx, 1);
        btn.classList.toggle('guia-proteina--ativa', respostas.proteinas_sensiveis.indexOf(p) !== -1);
        el('gs-next').disabled = respostas.proteinas_sensiveis.length === 0;
      });
    });
    el('gs-next').addEventListener('click', function() { if (respostas.proteinas_sensiveis.length > 0) avancar(); });
    el('gs-back').addEventListener('click', voltar);
    return;
  }

  if (step === 8 && respostas.necessidade === 'pele') { stepSobrepeso(); return; }

  // GASTRO step 6 — carbo
  if (step === 6 && respostas.necessidade === 'gastro') {
    c.innerHTML = '<h2 class="guia-step__titulo">O carboidrato piora os sintomas?</h2>' +
      '<p class="guia-step__sub">Isso ajuda a definir se a dieta deve ser também low carb.</p>' +
      renderOpcoes([
        { valor: 'sim', icon: '⚠️', label: 'Sim, percebo que piora',        sub: '' },
        { valor: 'nao', icon: '➖', label: 'Não ou não tenho certeza', sub: '' }
      ], respostas.carbo_piora === true ? 'sim' : respostas.carbo_piora === false ? 'nao' : '') + acoesPadrao;
    el('gs-next').disabled = respostas.carbo_piora === null;
    c.querySelectorAll('.guia-opcao').forEach(function(btn) {
      btn.addEventListener('click', function() {
        respostas.carbo_piora = btn.dataset.valor === 'sim';
        c.querySelectorAll('.guia-opcao').forEach(function(b) { b.classList.toggle('guia-opcao--ativa', b.dataset.valor === btn.dataset.valor); });
        el('gs-next').disabled = false;
      });
    });
    el('gs-next').addEventListener('click', function() { if (respostas.carbo_piora !== null) avancar(); });
    el('gs-back').addEventListener('click', voltar);
    return;
  }

  if (step === 7 && respostas.necessidade === 'gastro') { stepSobrepeso(); return; }
}

// ===== RESULTADO =====
function mostrarResultado() {
  el('guia-quiz-section').style.display = 'none';
  el('guia-resultado-section').style.display = 'block';

  var rec = calcularRecomendacao(respostas);

  var porcao = calcularPorcao(
    parseFloat(respostas.peso),
    respostas.fase,
    respostas.atividade,
    rec.linhaKey,
    respostas.sobrepeso || false
  );

  var primeiroSabor = rec.saboresPermitidos[0];
  var semProdutoDisponivel = !rec.saboresPermitidos.length;

  el('guia-res-nome').textContent = respostas.nome_cao || 'seu cão';

  var porcaoEl = document.querySelector('.gr__porcao');

  if (porcaoEl) {
    porcaoEl.style.display = semProdutoDisponivel ? 'none' : 'block';
  }

  if (!semProdutoDisponivel) {
    el('guia-res-porcao').textContent = porcao + 'g/dia';
  }

  var avisoEl = el('guia-res-aviso');
  var avisoTextoEl = el('guia-res-aviso-texto');

  if (rec.aviso) {
    avisoEl.style.display = 'flex';
    avisoTextoEl.textContent = rec.aviso;
  } else {
    avisoEl.style.display = 'none';
    avisoTextoEl.textContent = '';
  }

  var recommendationEl = el('guia-res-recommendation');

  if (recommendationEl) {
    recommendationEl.style.display = 'none';
  }

  el('guia-res-titulo').textContent = rec.titulo;
  el('guia-res-linha-sub').textContent = rec.criterio || (rec.linha + ' · Amordida');

  var imgEl = el('guia-res-img');
  if (imgEl && primeiroSabor) {
    imgEl.src = primeiroSabor.imagem;
    imgEl.alt = rec.titulo;
  } else if (imgEl) {
    imgEl.removeAttribute('src');
    imgEl.alt = rec.titulo;
  }

  var bens = BENEFICIOS[rec.linhaKey] || [];

  el('guia-res-beneficios').innerHTML = bens.map(function(b) {
    return '<div class="gr__beneficio">' +
      '<span class="gr__beneficio-icon">' + b.icon + '</span>' +
      '<p class="gr__beneficio-texto">' + b.texto + '</p>' +
    '</div>';
  }).join('');

  var labels = {
    filhote: 'Filhote',
    adulto: 'Adulto',
    senior: 'Sênior',
    sedentario: 'Sedentário',
    moderado: 'Moderado',
    ativo: 'Ativo',
    saude: 'Saúde geral',
    pele: 'Sensibilidade de pele',
    gastro: 'Sensibilidade gastrointestinal',
    peso: 'Controle de peso',
    seletividade: 'Seletividade alimentar'
  };

  var saboresTexto = rec.saboresPermitidos.map(function(s) {
    return s.label;
  }).join(', ');

  if (!saboresTexto) {
    saboresTexto = 'Atendimento recomendado';
  }

  var msg = encodeURIComponent(
    'Olá! Fiz o quiz do Guia Amordida.\n\n' +
    'Cão: ' + (respostas.nome_cao || '-') + '\n' +
    'Peso: ' + respostas.peso + 'kg\n' +
    'Fase: ' + (labels[respostas.fase] || respostas.fase) + '\n' +
    'Atividade: ' + (labels[respostas.atividade] || respostas.atividade) + '\n' +
    'Necessidade: ' + (labels[respostas.necessidade] || respostas.necessidade) + '\n' +
    'Linha recomendada: ' + rec.nomeResumo + '\n' +
    'Sabores indicados: ' + saboresTexto + '\n' +
    'Porção diária: ' + porcao + 'g/dia'
  );

  var waUrl = 'https://wa.me/5511965510392?text=' + msg;

  var wa = el('guia-res-whatsapp');
  if (wa) wa.href = waUrl;

  if (semProdutoDisponivel) {
    el('guia-res-produto').innerHTML =
      '<div class="gr__resultado-card gr__resultado-card--atendimento">' +
        '<div class="gr__resultado-head">' +
          '<span class="gr__resultado-label">Atendimento recomendado</span>' +
          '<h3 class="gr__resultado-title">Não encontramos uma opção compatível</h3>' +
          '<p class="gr__resultado-text">Com as informações preenchidas, o mais seguro é falar com nossa equipe antes de escolher um produto. Assim evitamos indicar uma linha que não atende bem às sensibilidades informadas.</p>' +
        '</div>' +
        '<a href="' + waUrl + '" target="_blank" rel="noopener" class="gr__linha-btn">' +
          'Conversar com especialista' +
        '</a>' +
      '</div>';
  } else {
    var linhaCompletaUrl = rec.saboresPermitidos[0]
      ? rec.saboresPermitidos[0].url.split('?')[0]
      : '#';

    el('guia-res-produto').innerHTML =
      '<div class="gr__resultado-card">' +
        '<div class="gr__resultado-head">' +
          '<span class="gr__resultado-label">Linha recomendada</span>' +
          '<h3 class="gr__resultado-title">' + rec.titulo + '</h3>' +
          '<p class="gr__resultado-text">' + (rec.criterio || '') + '</p>' +
        '</div>' +

        '<div class="gr__resultado-beneficios">' +
          '<span class="gr__resultado-label">Características da linha</span>' +
          '<div class="gr__beneficios">' +
            bens.map(function(b) {
              return '<div class="gr__beneficio">' +
                '<span class="gr__beneficio-icon"></span>' +
                '<p class="gr__beneficio-texto">' + b.texto + '</p>' +
              '</div>';
            }).join('') +
          '</div>' +
        '</div>' +

        '<div class="gr__sabores-header">' +
          '<span class="gr__sabores-label">Sabores indicados</span>' +
          '<p class="gr__sabores-texto">Você pode começar por qualquer uma dessas opções compatíveis com as respostas preenchidas.</p>' +
        '</div>' +

        '<div class="gr__sabores-grid">' +
          rec.saboresPermitidos.map(function(sabor) {
            return '<a href="' + addUtm(sabor.url) + '" class="gr__sabor-card">' +
              '<img src="' + sabor.imagem + '" alt="' + sabor.label + '" class="gr__sabor-img">' +
              '<div class="gr__sabor-info">' +
                '<span class="gr__sabor-nome">' + sabor.label + '</span>' +
                '<span class="gr__sabor-link">Ver sabor</span>' +
              '</div>' +
            '</a>';
          }).join('') +
        '</div>' +

        '<a href="' + addUtm(linhaCompletaUrl) + '" class="gr__linha-btn">' +
          'Conhecer linha completa' +
        '</a>' +
      '</div>';
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function addUtm(url) {
  if (!url) return '#';

  var sep = url.indexOf('?') === -1 ? '?' : '&';

  return url + sep +
    'utm_source=guia' +
    '&utm_medium=recomendacao' +
    '&utm_campaign=guia-amordida';
}

// ===== REINICIAR =====
function reiniciar() {
  step = 1;
  respostas = { nome_cao: '', peso: '', fase: '', atividade: '', necessidade: '', sabe_proteina: null, proteinas_sensiveis: [], carbo_piora: null, sobrepeso: null };
  el('guia-resultado-section').style.display = 'none';
  var aviso = el('guia-res-aviso');
  if (aviso) aviso.style.display = 'none';
  el('guia-entrada').style.display = 'block';
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// ===== INIT =====
document.addEventListener('DOMContentLoaded', function() {
  var btnIniciar = el('guia-btn-iniciar');
  if (btnIniciar) {
    btnIniciar.addEventListener('click', function() {
      el('guia-entrada').style.display = 'none';
      el('guia-quiz-section').style.display = 'block';
      renderStep();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  var btnReiniciar = el('guia-btn-reiniciar');
  if (btnReiniciar) btnReiniciar.addEventListener('click', reiniciar);
});

})();